import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  className?: string
}

function InfoAptaclub({ className }: Props) {
  return (
    <IconBase name="info-aptaclub" w={100} className={className}>
      <rect width="100" height="100" fill="white" />
      <g clip-path="url(#clip0_45_78)">
        <path
          d="M77.0963 24.5296L65.0915 12.8803C64.8385 12.6339 64.5047 12.5 64.1494 12.5H22.5958C21.8529 12.5 21.25 13.0999 21.25 13.839V86.161C21.25 86.9001 21.8529 87.5 22.5958 87.5H76.1542C76.8971 87.5 77.5 86.9001 77.5 86.161V25.4883C77.5 25.1294 77.3547 24.7813 77.0963 24.5296ZM65.1561 16.683L73.2041 24.4921H65.1561V16.683ZM23.9416 84.822V15.178H62.4645V25.8311C62.4645 26.5702 63.0674 27.1701 63.8103 27.1701H74.8137V84.822H23.9416Z"
          fill="#224794"
        />
        <path
          d="M65.4521 40.9296H32.5548C31.8119 40.9296 31.209 40.3297 31.209 39.5906C31.209 38.8515 31.8119 38.2516 32.5548 38.2516H65.4521C66.195 38.2516 66.7979 38.8515 66.7979 39.5906C66.7979 40.3297 66.195 40.9296 65.4521 40.9296Z"
          fill="#4A9BD4"
        />
        <path
          d="M65.4521 62.6054H32.5548C31.8119 62.6054 31.209 62.0055 31.209 61.2664C31.209 60.5272 31.8119 59.9274 32.5548 59.9274H65.4521C66.195 59.9274 66.7979 60.5272 66.7979 61.2664C66.7979 62.0055 66.195 62.6054 65.4521 62.6054Z"
          fill="#4A9BD4"
        />
        <path
          d="M65.4521 51.7702H32.5548C31.8119 51.7702 31.209 51.1703 31.209 50.4312C31.209 49.692 31.8119 49.0922 32.5548 49.0922H65.4521C66.195 49.0922 66.7979 49.692 66.7979 50.4312C66.7979 51.1703 66.195 51.7702 65.4521 51.7702Z"
          fill="#4A9BD4"
        />
        <path
          d="M53.7973 73.4458H32.5548C31.8119 73.4458 31.209 72.8459 31.209 72.1068C31.209 71.3677 31.8119 70.7678 32.5548 70.7678H53.7919C54.5348 70.7678 55.1377 71.3677 55.1377 72.1068C55.1377 72.8459 54.5348 73.4458 53.7919 73.4458H53.7973Z"
          fill="#4A9BD4"
        />
      </g>
      <defs>
        <clipPath id="clip0_45_78">
          <rect width="56.25" height="75" fill="white" transform="translate(21.25 12.5)" />
        </clipPath>
      </defs>
    </IconBase>
  )
}

export default InfoAptaclub
